import {KlassDropdown} from "components"
import CampusSelect from "components/CampusSelect"
import ProgramSelect from "components/ProgramSelect"
import {UserOptionLabel} from "components/UserSelect/UserSelect"
import UserSelectV3 from "components/UserSelectV3"
import {useAdvisors} from "hooks"
import {useMemo} from "react"
import {Auth} from "types/auth"
import {AppliedFilter, FieldType, FilterKey} from "types/filter"
import {VoiceMailReadStatusOptions} from "types/student-voice-mail"
import {FilterField, KlassappFilters} from "uiKit"

type Props = {
    filterKey?: FilterKey
    onApplyFilter: (payload: AppliedFilter) => void
    initialFilter?: AppliedFilter
    onClearFilter: () => void
}

export function StudentVoiceMailFilter(props: Props) {
    const {filterKey, initialFilter, onApplyFilter, onClearFilter} = props
    const {admissionAdvisors} = useAdvisors().data || {}

    const availableFilters = useMemo(() => {
        let filters: FilterField[] = [
            {
                field: "students",
                label: "Students",
                type: FieldType.List,
                renderForm: (props: any) => {
                    return (
                        <UserSelectV3
                            type={[Auth.UserProfileType.Student]}
                            belongsToMyCampuses={false}
                            isMulti
                            placeholder="Students"
                            {...props}
                        />
                    )
                }
            },
            {
                field: "status",
                label: "Read Status",
                type: FieldType.List,
                renderForm: (props: any) => {
                    return <KlassDropdown options={VoiceMailReadStatusOptions} placeholder="Read Status" {...props} />
                }
            },
            {
                field: "program",
                label: "Program",
                type: FieldType.List,
                renderForm: (props: any) => {
                    return <ProgramSelect isMulti placeholder="Program" {...props} />
                }
            },
            {
                field: "campus",
                label: "Campus",
                type: FieldType.List,
                renderForm: (props: any) => {
                    return <CampusSelect isMulti placeholder="Campus" {...props} />
                }
            },
            {
                field: "admAdvisors",
                label: "Admissions Advisors",
                type: FieldType.List,
                renderForm: (props: any) => {
                    return (
                        <KlassDropdown
                            isMulti
                            options={admissionAdvisors}
                            valueKey="profileId"
                            labelKey="fullName"
                            getOptionLabel={UserOptionLabel}
                            placeholder="Admissions Advisors"
                            {...props}
                        />
                    )
                }
            },
            {
                field: "createdAtRange",
                label: "Logged Date",
                type: FieldType.Date
            }
        ]

        return filters
    }, [admissionAdvisors])

    return (
        <KlassappFilters
            filterKey={filterKey}
            availableFilters={availableFilters}
            initialFilter={initialFilter}
            onApply={onApplyFilter}
            onClear={onClearFilter}
        />
    )
}
